<template>

  <!-- Footer -->
  <v-footer height="auto" class="footerShp">
    <a href="https://www.datadec.es" target="_blank" rel="noopener noreferrer" class="mx-auto"><span class="footerInfo"> {{ this.$t('poweredDatadec') }} </span></a>
  </v-footer>

</template>

<script>

export default {
  name: 'FooterApp',
  components: {
  },
  watch: {

  },

  data () {
    return {
      icons: ['fab fa-facebook', 'fab fa-twitter', 'fab fa-google-plus', 'fab fa-linkedin', 'fab fa-instagram']
    }
  },
  created () {
  },
  beforeDestroy () {
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ShpFooterApp.vue